import * as React from 'react'

import styles from './PrimaryButton.module.scss'
import LinkComponent from '../LinkComponent/LinkComponent'

type ButtonProps = {
  children: any
  onClick?: any
  disabled?: boolean
  to?: string
}

const PrimaryButton = ({
  children,
  onClick,
  disabled,
  to,
}: ButtonProps): JSX.Element =>
  to ? (
    <LinkComponent className={styles.link} to={to}>
      <button
        className={
          disabled ? styles.disabledPrimaryButton : styles.primaryButton
        }
        onClick={onClick}
      >
        {children}
      </button>
    </LinkComponent>
  ) : (
    <button
      className={disabled ? styles.disabledPrimaryButton : styles.primaryButton}
      onClick={onClick}
    >
      {children}
    </button>
  )

export default PrimaryButton
